import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Grid } from '@mui/material';
import clsx from 'clsx';

import { useDataContext } from 'components/OnePageTemplates/context';
import { InfoCard } from 'components/OnePageTemplates/OnePageSecondStyle/components/InfoCard';

import { hasMeaningfulValues } from 'helpers/hasMeaningfulValues';

import styles from './TeamSectionDesktop.module.scss';

export const TeamSectionDesktop: React.FC = () => {
  const [activeCardIndex, setActiveCardIndex] = useState(0);

  const { data } = useDataContext();
  const { t } = useTranslation();

  const { teamMembers } = data;

  if (!hasMeaningfulValues({ teamMembers }) || !teamMembers) {
    return null;
  }

  const handleCardClick = (index: number) => {
    setActiveCardIndex(index);
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.teamMemberContainer}>
        <Box sx={{ display: 'flex', marginBottom: '32px', alignItems: 'center' }}>
          {teamMembers[activeCardIndex].photoSrc && (
            <img
              className={styles.imageContainer}
              src={teamMembers[activeCardIndex].photoSrc || ''}
              alt={t('onePageMapping.teamMemberPhoto')}
            />
          )}
          <Box className={styles.teamMemberInfoContainer}>
            {teamMembers[activeCardIndex].fullName && (
              <Box className={styles.teamSectionTitle}>{teamMembers[activeCardIndex].fullName}</Box>
            )}
            {teamMembers[activeCardIndex].position && <Box>{teamMembers[activeCardIndex].position}</Box>}
          </Box>
        </Box>
        <Grid container spacing={4}>
          {teamMembers[activeCardIndex].dateOfBirth && (
            <Grid item xs={12}>
              <Box className={styles.teamMemberContainerTitle}>{t('onePageMapping.dateBirth')}</Box>
              <Box className={styles.teamMemberContainerDescription}>{teamMembers[activeCardIndex].dateOfBirth}</Box>
            </Grid>
          )}
          {teamMembers[activeCardIndex].education && (
            <Grid item xs={12}>
              <Box className={styles.teamMemberContainerTitle}>{t('management.team.education')}</Box>
              <Box className={styles.teamMemberContainerDescription}>{teamMembers[activeCardIndex].education}</Box>
            </Grid>
          )}
          {teamMembers[activeCardIndex].workExperience && (
            <Grid item xs={12}>
              <Box className={styles.teamMemberContainerTitle}>{t('management.team.workExperience')}</Box>
              <Box className={styles.teamMemberContainerDescription}>{teamMembers[activeCardIndex].workExperience}</Box>
            </Grid>
          )}
          {teamMembers[activeCardIndex].keySkills && (
            <Grid item xs={12}>
              <Box className={styles.teamMemberContainerTitle}>{t('management.team.keySkills')}</Box>
              <Box className={styles.teamMemberContainerDescription}>{teamMembers[activeCardIndex].keySkills}</Box>
            </Grid>
          )}
          {teamMembers[activeCardIndex].achievements && (
            <Grid item xs={12}>
              <Box className={styles.teamMemberContainerTitle}>{t('onePageMapping.achievements')}</Box>
              <Box className={styles.teamMemberContainerDescription}>{teamMembers[activeCardIndex].achievements}</Box>
            </Grid>
          )}
        </Grid>
      </Box>
      <Box className={styles.teamMemberList}>
        {teamMembers.map(({ fullName, position }, index) => (
          <InfoCard
            value={fullName}
            label={position}
            key={index}
            variant={'green'}
            labelStyles={styles.cardLabel}
            valueStyles={styles.cardTitle}
            cardStyles={clsx(styles.cardStyles, {
              [styles.activeCard]: index === activeCardIndex,
            })}
            onClick={() => handleCardClick(index)}
          />
        ))}
      </Box>
    </Box>
  );
};
